module.exports = __webpack_public_path__ + "static/media/total-tires-icon.b472006e.svg";